import { LockSimple } from "@/components/ui/icons";

/**
 * Replaces the composer when the viewer doesn't have permission to post
 * in the current channel. Disabled affordance, no editor, no toolbar.
 */
export function MessageInputLocked() {
  return (
    <div className="relative">
      <div className="p-3">
        <div className="bg-secondary/50 rounded-lg px-4 py-3 flex items-center gap-2 text-muted-foreground">
          <LockSimple size={18} />
          <span className="text-sm">
            You don't have permission to post in this channel
          </span>
        </div>
      </div>
    </div>
  );
}
